export default {"id":"85a60a16","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}